import type { StageId } from '@/types/stage-theme';

export type AppThemeMode = 'STATIC' | 'DYNAMIC';

function requireEnv(key: keyof ImportMetaEnv): string {
  const value = import.meta.env[key];
  if (!value?.trim()) {
    throw new Error(`Missing required environment variable: ${key}`);
  }
  return value.trim();
}

function optionalEnv(key: keyof ImportMetaEnv): string {
  return import.meta.env[key]?.trim() ?? '';
}

function toStageNumber(value: string | undefined): StageId {
  return Number(value) as StageId;
}

function toThemeMode(value: string | undefined): AppThemeMode {
  return value?.trim().toUpperCase() === 'DYNAMIC' ? 'DYNAMIC' : 'STATIC';
}

export const appConfig = {
  api: {
    baseUrl: requireEnv('VITE_API_BASE_URL'),
    mockUserSessionUrl: optionalEnv('VITE_MOCK_USER_SESSION_URL'),
    adminBaseUrl: optionalEnv('VITE_ADMIN_API_BASE_URL'),
  },
  stage: {
    id: optionalEnv('VITE_STAGE_ID'),
    number: toStageNumber(import.meta.env.VITE_STAGE_NUMBER),
    contentGameType: optionalEnv('VITE_STAGE_CONTENT_GAME_TYPE') || 'MAZE_NAVIGATION',
    themeMode: toThemeMode(import.meta.env.VITE_THEME_MODE),
  },
  encryption: {
    enabled: import.meta.env.VITE_ENCRYPTION_ENABLED === 'true',
    key: optionalEnv('VITE_ENCRYPTION_KEY'),
  },
} as const;

export type AppConfig = typeof appConfig;
